__turbopack_context__.v({
  "button": "FoldAccordionButton-module-scss-module__UuZ1kq__button",
  "click-area": "FoldAccordionButton-module-scss-module__UuZ1kq__click-area",
  "description": "FoldAccordionButton-module-scss-module__UuZ1kq__description",
  "only-title": "FoldAccordionButton-module-scss-module__UuZ1kq__only-title",
  "title": "FoldAccordionButton-module-scss-module__UuZ1kq__title",
  "wrapper": "FoldAccordionButton-module-scss-module__UuZ1kq__wrapper",
});
